import type { EnergyAnalysisRow } from "features/energy-analysis-dashboard/model/types";

import { collectYears, sumValues } from "features/energy-analysis-dashboard/lib/aggregate";
import { getItemColor } from "utils/dynamicDashboard";

import type { CrremDashboardScenario } from "../model/types";

import { formatCorrectionLabel } from "./formatScenarioLabel";
import { pickDashboardMetric } from "./parseCrremDashboardApi";
import { scaleChartValue } from "./scaleChartValues";

export const toYearlyPoints = (rows: EnergyAnalysisRow[]) =>
  collectYears(rows).map((year) => ({ value: sumValues(rows.filter((row) => row.year === year)), year }));

export const buildCorrectionOverlayLines = (
  scenarios: CrremDashboardScenario[],
  metric: "co2" | "kwh",
  divisor?: number
) =>
  scenarios.map((scenario, index) => ({
    color: getItemColor(index),
    id: scenario.id,
    name: formatCorrectionLabel(scenario.corrections, scenario.label),
    points: toYearlyPoints(pickDashboardMetric(scenario, metric).rows).map((point) => ({
      ...point,
      value: scaleChartValue(point.value, divisor),
    })),
  }));

export const scaleStackSeries = (
  series: { color: string; data: number[]; name: string }[],
  sourceYears: number[],
  years: number[],
  divisor?: number
) =>
  series.map((item) => ({
    ...item,
    data: years.map((year) => scaleChartValue(item.data[sourceYears.indexOf(year)] ?? 0, divisor)),
  }));
